import React from 'react';
import { motion } from 'framer-motion';
import { Network, Database, Plug } from 'lucide-react';

const advantages = [
  {
    icon: Network,
    label: 'Built-in Distribution',
    desc: 'Direct access to thousands of end customers through the platforms they already use daily.',
  },
  {
    icon: Database,
    label: 'Proprietary Data',
    desc: 'Years of operational data — transactions, workflows, customer behavior — ready to train AI models.',
  },
  {
    icon: Plug,
    label: 'Deep Integration',
    desc: 'We own the system of record, so our AI products plug directly into mission-critical workflows.',
  },
];

const LabsAdvantages: React.FC = () => {
  return (
    <section className="relative py-24 px-6 sm:px-8 lg:px-12 border-t border-[#1F1F2E]/50">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <span className="text-[10px] uppercase tracking-[0.25em] text-[#3B82F6]/50 mb-3 block">
            Why Noa Labs
          </span>
          <h2 className="font-space-grotesk text-3xl sm:text-4xl font-bold text-white">
            Our Unfair Advantage
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-3 gap-0">
          {advantages.map((a, i) => (
            <motion.div
              key={a.label}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className={`py-8 ${i < 2 ? 'sm:pr-10 sm:border-r sm:border-[#1F1F2E]/40' : ''} ${i > 0 ? 'sm:pl-10' : ''}`}
            >
              <a.icon className="w-5 h-5 text-[#3B82F6]/60 mb-5" strokeWidth={1.5} />
              <h3 className="text-white font-semibold text-base mb-2">{a.label}</h3>
              <p className="text-[#A1A1AA]/50 text-sm leading-relaxed">{a.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LabsAdvantages;
